// Replace undefined with the custom phone number regular expression.
const evaPhoneRegExp: RegExp | undefined = /^1[3-9]\d{9}$/;

export const isValidEvaPhoneNumber = (
  phone: string,
  phoneRegExp: RegExp | undefined = evaPhoneRegExp
) => phoneRegExp.test(phone);
